<template>
  <div>
    <div>
      <vs-row>
        <vs-col>
          <span class="bold-text" style="font-size: 18px;">순회점검(주1회), 합동 안전․보건점검(분기1회)</span>
        </vs-col>
      </vs-row>
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>순회점검</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8">
        <vs-col>
          <p class="semi-bold-text">· 도급인 사업주는 작업장을 정기적으로 순회점검(1주일에 1회이상)실시</p>
          <p class="normal-text ml-4">※ 단, 건설업, 제조업, 토사석 광업, 서적·잡지 및 기타 인쇄물 출판업, 음악 및 기타 오디오물 출판업, 금속 및 비금속 원료 재생업은 2일에 1회 이상 실시</p>
          <p class="semi-bold-text">· 사업주가 경영관리 등으로 직접 점검 곤란 시 사업담당자가 점검하고, 점검의 결과 및 조치의 이행여부 등에 대해 보고 받아야 함</p>
          <p class="semi-bold-text">· 주 1회 이상(건설은 2일 1회)</p>
          <p class="normal-text ml-4">1주일 이내 종료되는 사업의 경우 1회 이상 실시</p>
        </vs-col>
      </vs-row>

      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>합동 안전·보건점검</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8">
        <vs-col>
          <p class="semi-bold-text">· 도급 사업시 도급인 및 관계수급인은 합동으로 수행중인 작업에 대해 안전보건조치의 적정성 여부를 점검 및 조치하여야 한다.</p>
          <p class="semi-bold-text">· (구성)  ①도급인  ②관계수급인 ③ 도급인 및 관계수급인 근로자 각 1명</p>
          <p class="normal-text ml-4">* 도급인 및 관계수급인 사업주(같은 사업내에 지역을 달리하는 사업장이 있는 경우 그 사업장의 안전보건관리책임자), 도급인 및 관계수급인 근로자(관계수급인의 근로자는 해당공정 근로자만 해당-수급인이 다수인 경우 각 수급인 소속 근로자 1명 씩 점검에 참여하되, 해당공정에 참여)</p>
          <p class="semi-bold-text">· 분기 1회 이상(건설은 2개월 1회)</p>
        </vs-col>
      </vs-row>

      <vs-row class="mb-8" style="border:1px solid #cdcdcd;">
        <vs-col>
          <ul class="table table-1" style="border-bottom:none;">
            <li class="justify-start" style="background-color: #fafafa">
              <div>
                <span class="px-4 bold-text">관련법령</span>
              </div>
            </li>
            <li class="justify-start p-4 text-left">
              <div>
                <p class="semi-bold-text">· 산업안전보건법 제64조(도급에 따른 산업재해 예방조치)</p>
                <p class="normal-text ml-4">① 2. <span style="color: #FF8510">작업장 순회점검</span></p>
                <p class="normal-text ml-4">② 도급인은 자신의 근로자 및 관계수급인 근로자와 함께 정기적으로 또는 수시로 작업장의 안전   및 보건에 관한 점검을 하여야 한다.</p>
                <p class="semi-bold-text">· 산업안전보건법 시행규칙 제80조(도급사업 시의 안전․보건조치 등)</p>
                <p class="normal-text ml-4">① 2.제1호 각 목의 사업을 제외한 사업: <span style="color: #FF8510">1주일에 1회 이상</span></p>
                <p class="normal-text ml-4">② <span style="color: #EA5455">관계수급인은 제1항에 따라 도급인이 실시하는 순회점검을 거부·방해 또는 기피해서는 안 되며 점검 결과 도급인의 시정요구가 있으면 이에 따라야 한다.</span></p>
                <p class="normal-text ml-4">☞ 위반에 대한 조치: 500만원 이하의 벌금</p>
                <p class="semi-bold-text">· 산업안전보건법 시행규칙 제82조(도급사업의 합동 안전․보건점검)</p>
                <p class="normal-text ml-4">② 2. 제1호의 사업을 제외한 사업: <span style="color: #FF8510">분기에 1회 이상</span></p>
                <p class="normal-text ml-4">☞ 위반에 대한 조치: 500만원 이하의 벌금</p>
              </div>
            </li>
          </ul>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'

export default {
  components: {
    FieldSelectModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FileUploadModule
  },
}
</script>

<style scoped>
.bold-text {
  font-weight: 700;
  font-size: 16px;
}
.semi-bold-text {
  font-weight: 500;
  font-size: 14px;
}

.normal-text {
  font-weight: 400;
}
</style>
